import Services from "services"

class PermintaanPerubahanDataApi {
  async getList(params) {
    const fetch = await Services.get("/permintaan_perubahan_data/page", {
      params,
    })
    return fetch.data
  }

  getSingle(params) {
    return Services.get("/permintaan_perubahan_data/single", { params })
  }

  generateNumber(params) {
    return Services.get("/permintaan_perubahan_data/no_baru", { params })
  }

  getHakAkses(params) {
    return Services.get("/hak_akses", { params })
  }

  async getDropdownUrgensi() {
    return [
      { label: "Sangat Tinggi", value: "Sangat Tinggi" },
      { label: "Tinggi", value: "Tinggi" },
      { label: "Sedang", value: "Sedang" },
      { label: "Rendah", value: "Rendah" },
      { label: "Sangat Rendah", value: "Sangat Rendah" }
    ]
  }

  async getDropdownStatusApproval() {
    return [
      { label: "PENDING", value: "PEN" },
      {
        value: "VER",
        label: "VERIFIED",
      },
      {
        value: "APP",
        label: "APPROVED",
      },
      {
        value: "REV",
        label: "REVISI",
      },
      {
        value: "REJ",
        label: "REJECT",
      },
    ]
  }

  approve(data) {
    return Services.post("/approval_permintaan_perubahan_data/approve", data)
  }

}

export default new PermintaanPerubahanDataApi()
